import vue from '@/main'

import axios from "../../axios"
import store from "../../store/store"

import { formatRouteTenantPath } from '@/utils'

axios.interceptors.request.use(
  config => {
    if (store.state.showLoadingOverlay) {
      if (config.data.query.includes('newAttendanceToCustomer')) {
        vue.$vs.loading({
          type: 'radius',
          text: 'Estamos verificando se esse contato é valido e possui whatsapp...'
        });
      } else {
        vue.$vs.loading({
          type: 'radius',
          text: (config.data.query && config.data.query.includes('createCampaign ('))
            ? 'Criando campanha. O tempo pode variar de acordo com a quantidade de contatos...'
            : ''
        });
      }
    }
    
    // Do something before request is sent
    const accessToken = localStorage.getItem('accessToken')
    if (accessToken) {
      config.headers['Authorization'] = 'Bearer ' + accessToken
    }

    config.timeout = 0;
    return config
  },
  error => {
    Promise.reject(error)
  })

axios.interceptors.response.use(
  response => {
    vue.$vs.loading.close()

    return response
  },
  async error => {
    if(
        error && error.response && error.response.data
        && error.response.data.message === 'O que foi descrito não pode ser salvo, sugere um tipo de ataque ou inserção de scripts maliciosos evite usar |, <, >'
        && error.response.data.code === 400
      ) {
      vue.$vs.notify({
        title: 'Possível tentativa de Ataque',
        text: error.response.data.message,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })
    }
    vue.$vs.loading.close()
    const { config, response } = error
    const originalRequest = config
    
    if (response && response.status !== 200) {
      vue.$vs.loading.close('#chats-list > .con-vs-loading')
      vue.$vs.loading.close('#loading-customer-chats > .con-vs-loading')
      vue.$vs.loading.close('#infinite-list > .con-vs-loading')
    }

    if (response && response.status === 401) {
      for (const error of response.data.errors) {
        if (error.message === 'Token has expired') {
          const accessToken = await store.dispatch("auth/refreshAccessToken")
          originalRequest.headers.Authorization = 'Bearer ' + accessToken

          return Promise.resolve(axios(originalRequest))
        }

        if (error.message === 'Unauthorized') {
          localStorage.removeItem("accessToken")
          localStorage.removeItem("groupsSelectedFilter")
          return vue.$router.push(formatRouteTenantPath('/login'))
        }
      }
    }

    if ( response && response.data.errors[0].message === 'validation' ) {
      vue.$vs.notify({
        title: 'Erro nos dados informados.',
        text: response.data.errors[0].validation[Object.keys(response.data.errors[0].validation)[0]][0],
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })
    } else if ( response ) {
      vue.$vs.notify({
        title: 'Algo está errado.',
        text:  response.data.errors ? response.data.errors[0].message : null,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })
    }

    return Promise.reject(error)
  })

export default axios
